<template>
  <v-layout
    v-if="order"
    row
    wrap
    color="transparent"
  >
    <!-- Title -->
    <v-flex xs12>
      <h4 class="text--secondary">
        {{ $t('Created At') }} {{ order.created_at | timezone }}
      </h4>
      <v-chip v-if="!order.customer.customer_id">
        <v-icon class="mr-1">fiber_manual_record</v-icon>
        {{ $t('Guest') }}
      </v-chip>
      <v-chip>
        <v-icon class="mr-1">fiber_manual_record</v-icon>
        {{ status }}
      </v-chip>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderSingleHeader',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    status () {
      return this.$t(this.order.status).charAt(0).toUpperCase() + this.$t(this.order.status).slice(1).replace('_', ' ')
    }
  }
}
</script>
